import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import PopUpContainer from 'src/components/common/modal/PopUp';

type IProps = {
  isOpen: boolean;
  onClose: () => void;
};

const BuyNowDialog: FC<IProps> = ({ isOpen, onClose }) => {
  const { t }: Translation = useTranslation();

  return (
    <PopUpContainer
      isOpen={isOpen}
      handleClose={onClose}
      hasOverlay
      title={t('safe_promo.buyNowModalTitle')}
      description={t('safe_promo.buyNowModalDescription')}
      zIndex={250}
      handleOK={onClose}
      handleCancel={onClose}
    ></PopUpContainer>
  );
};

export default BuyNowDialog;
